<div class="modal-box dms-change-form-modal" cdkDrag>
  <form class="dms-change-form-modal__form" [formGroup]="dmsForm" (ngSubmit)="onSubmit()" id="dms-form">
    <div class="modal-header dms-change-form-modal__header" cdkDragHandle>
        <div class="dms-change-form-modal__headline">
            <span class="dms-change-form-modal__eyebrow">{{ 'FORMS' | translate }}</span>
            <h4 class="modal-title dms-change-form-modal__title">{{ 'CHANGE_DMS' | translate }}</h4>
        </div>
        <button type="button" class="dms-change-form-modal__close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    
    <div class="modal-body dms-change-form-modal__body">
        <section class="dms-change-form-modal__panel">
            <div class="dms-change-form-modal__stack">
                <div class="dms-change-form-modal__field">
                    <label class="dms-change-form-modal__label">{{ 'CLIENT' | translate }}*</label>
                    <ng-select [clearable]="false" [attr.aria-label]="'SELECT_A_CLIENT' | translate"
                        [ngClass]="{ 'is-invalid': dmsForm.get('clientId')?.touched && dmsForm.get('clientId')?.invalid }"
                        bindLabel="fullName" bindValue="id" [items]="allClients" formControlName="clientId">
                    </ng-select>
                    <div *ngIf="dmsForm.get('clientId')?.invalid && dmsForm.get('clientId')?.touched" class="dms-change-form-modal__feedback">{{ 'THIS_FIELD_IS_REQUIRED' | translate }}</div>
                </div>
                <div class="dms-change-form-modal__field">
                    <label class="dms-change-form-modal__label">{{ 'NEW_DMS' | translate }}*</label>
                    <ng-select [clearable]="false" [attr.aria-label]="'SELECT_A_DMS' | translate"
                        [ngClass]="{ 'is-invalid': dmsForm.get('NewDMS')?.touched && dmsForm.get('NewDMS')?.invalid }"
                        bindLabel="fullName" bindValue="id" [items]="dmsOptions" formControlName="NewDMS">
                    </ng-select>
                    <div *ngIf="dmsForm.get('NewDMS')?.invalid && dmsForm.get('NewDMS')?.touched" class="dms-change-form-modal__feedback">{{ 'THIS_FIELD_IS_REQUIRED' | translate }}</div>
                </div>
                <div class="dms-change-form-modal__field">
                    <label class="dms-change-form-modal__label">{{ 'NOTES' | translate }}</label>
                    <textarea rows="5" class="form-control dms-change-form-modal__control dms-change-form-modal__control--textarea" formControlName="Notes" placeholder=""></textarea>
                </div>
            </div>
        </section>
    </div>
    <div class="modal-footer dms-change-form-modal__footer" cdkDragHandle>
        <div class="dms-change-form-modal__actions">
            <button class="red-outline-button dms-change-form-modal__button" type="button" (click)="close()">{{ 'CANCEL' | translate }}</button>
            <button class="blue-button dms-change-form-modal__button" id="submit-change-dms" type="submit" [disabled]="dmsForm.invalid || dmsForm.disabled">{{ 'SUBMIT' | translate }}</button>
        </div>
    </div>
  </form>
</div>
